import { render, staticRenderFns } from "./SWIFTValidation.vue?vue&type=template&id=c8b3213e&scoped=true"
import script from "./SWIFTValidation.vue?vue&type=script&lang=ts"
export * from "./SWIFTValidation.vue?vue&type=script&lang=ts"
import style0 from "./SWIFTValidation.vue?vue&type=style&index=0&id=c8b3213e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b3213e",
  null
  
)

export default component.exports